import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {RESOURCES as resources} from '../resourcesEvent';
import {setEventConfig} from '../store/actions';
import {makeGetDataRequest} from './getRequest';
import Config from '../config';

/**
 * Component for retrieving default Event Configuration
 */
class APIEventConfiguration extends Component {

    componentDidMount() {
        this.getGlobalEventConfigurations();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.refresh  && !prevProps.refresh) {
            this.getGlobalEventConfigurations();
        }
    }

    /**
     * Get Configuration
     */
    getGlobalEventConfigurations = () => {
        const configDefaults = Config.eventConfigDefault;
        const request = makeGetDataRequest(resources, 'EventConfiguration', 'GET_LIST', null);
        request.then(result => {
            let configs = JSON.parse(JSON.stringify(configDefaults));
            if (result) {
                if (typeof result === 'string') {
                    console.log('Event Configuration Retrieval Error: ', result);
                    this.props.setEventConfig(configs);
                    return Promise.resolve(configs);
                }
                for (let i = 0; i < result.length; i++) {
                    const config = result[i];
                    configs[config.name] = config?.value ?? configDefaults[config.name];
                }
                this.props.setEventConfig(configs);
                if (typeof this.props.onResult === 'function') {
                    this.props.onResult();
                }
                return Promise.resolve(configs);
            } else {
                console.log('Event Configuration Retrieval Error: No result');
                return Promise.reject('Event Configuration Retrieval failed');
            }
        }).catch(error => {
            console.log('Event Retrieval Error: ', error);
            return Promise.reject('Server Error');
        });
    };

    render() {
        return (
            <>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        event_config_refresh: state.event_config_refresh
    };
};

const mapDispatchToProps = {
    setEventConfig: setEventConfig
};

APIEventConfiguration.propTypes = {
    onResult: PropTypes.func,
    refresh: PropTypes.bool,
};

APIEventConfiguration.defaultProps = {
    refresh: false,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(APIEventConfiguration);
